import type { Gallery, CreateGalleryRequest, UpdateGalleryRequest, ReorderGalleryRequest } from '../features/gallery/types';
import { api } from './client';

export async function getGallery(): Promise<Gallery[]> {
  return api.get<Gallery[]>('/api/gallery');
}

export async function getPublicGallery(): Promise<Gallery[]> {
  return api.get<Gallery[]>('/api/gallery/public');
}

export async function getGalleryById(id: string): Promise<Gallery> {
  return api.get<Gallery>(`/api/gallery/${id}`);
}

export async function createGallery(data: CreateGalleryRequest): Promise<Gallery> {
  return api.post<Gallery>('/api/gallery', data);
}

export async function updateGallery(id: string, data: UpdateGalleryRequest): Promise<Gallery> {
  return api.patch<Gallery>(`/api/gallery/${id}`, data);
}

export async function deleteGallery(id: string): Promise<void> {
  return api.delete(`/api/gallery/${id}`);
}

export async function reorderGallery(data: ReorderGalleryRequest): Promise<{ success: boolean }> {
  return api.post<{ success: boolean }>('/api/gallery/reorder', data);
}
